@defer (when gridOptions()) {
  <div class="grid-container" id="grid-container" [class]="{ hidden: hidden() }" [class.loading]="isLoading()">
    <div class="grid-container_header" id="grid-container_header"></div>
    <div class="grid-container_header__filters" id="grid-container_header__filters">
      <div class="left">
        @if (showSearch()) {
          <form [formGroup]="searchForm" class="search-form" id="search-form">
            <motif-form-field>
              <input
                type="text"
                motifInput
                motifSearch
                [formControl]="searchControl"
                [placeholder]="'commonGrid.search' | translate"
                aria-label="Search"
                #searchInput />
            </motif-form-field>

          </form>
        }
      </div>
      <div class="right">
        <div class="grid-buttons">
          @for (button of gridButtons(); track button) {
            <app-grid-button [button]="button"></app-grid-button>
          }
        </div>
        @if (export$() !== undefined) {
          <app-long-action-button
            [iconFunction]="exportIcon"
            color="secondary"
            [label]="'commonGrid.export-title' | translate"
            [action$]="export$()!" />
        }
        @if (showFilter()) {
          <button
            motifButton
            class="borderless-button"
            color="secondary"
            (click)="onFilterClick()"
            id="filters-pane-button">
            <motif-icon [iconFunction]="filterListIcon"></motif-icon>
            {{ 'commonGrid.filter.title' | translate }}
          </button>
        }
      </div>
    </div>
    @if (showFilter() && chipsFilters().length > 0) {
      <div class="grid-container_header__chips-container" id="grid-container_header__chips-container">
        <app-filter-chips
          [showTitle]="true"
          [filters]="chipsFilters()"
          [filterCriteria]="filterCriteria()"
          (removeChip)="onRemoveChip($event)"
          (removeAll)="onRemoveAll()" />
      </div>
    }
    <motif-table
      (gridReady)="gridReady($event)"
      (sortChanged)="onSortChanged($event)"
      [animateRows]="false"
      [columnDefs]="columns()"
      [defaultColDef]="{
        sortable: true,
        resizable: true,
      }"
      [gridOptions]="gridOptions()"
      [headerHeight]="44"
      [pagination]="false"
      [rowClass]="'table-row'"
      [rowData]="rows()"
      [suppressHorizontalScroll]="false"
      [suppressRowClickSelection]="true"
      (selectionChanged)="onSelectionChanged()"
      class="grid-container_table"
      [class.no-radius]="showPagination() && numberOfRows() > 0"
      [class.loading]="isLoading()"
      id="grid-container_table"></motif-table>

    @if (showPagination() && numberOfRows() > 0) {
      <div class="pagination" id="pagination-bottom">
        <app-pagination
          [currentPage]="currentPage()"
          [numberOfPages]="numberOfPages()"
          [numberOfRows]="numberOfRows()"
          [pageSizeOptions]="pageSizeOptions"
          [currentPageSize]="currentPageSize"
          (pageChanged)="pageChanged($event)"
          (pageSizeChanged)="pageSizeChanged($event)">
        </app-pagination>
      </div>
    }

    @if (isLoading()) {
      <app-overlay-spinner />
    }
  </div>
}
